import V3API from '@/api/v3';

const GET_DOCS = 'GET_DOCS';
const GET_DOCS_SUCCESS = 'GET_DOCS_SUCCESS';
const GET_DOCS_FAILED = 'GET_DOCS_FAILED';

const SHOW_DOC = 'SHOW_DOC';
const SHOW_DOC_SUCCESS = 'SHOW_DOC_SUCCESS';
const SHOW_DOC_FAILED = 'SHOW_DOC_FAILED';

const namespaced = true;

const state = {
  docs: [],
  docDetails: {},
  loading: false,
};

const getters = {
  allDocs: (state) => {
    return state.docs;
  },

  docDetails: (state) => {
    return state.docDetails;
  },

  isLoading: (state) => {
    return state.loading;
  },
};

const actions = {
  async list({ commit }, payload) {
    let response;

    commit(GET_DOCS);

    try {
      response = await V3API.documentation.docsList(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DOCS_FAILED);
        reject(response);
      } else {
        commit(GET_DOCS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  async docGet({ commit }, id) {
    let response;

    commit(SHOW_DOC);

    try {
      response = await V3API.documentation.docGet(id);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(SHOW_DOC_FAILED);
        reject(response);
      } else {
        commit(SHOW_DOC_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  async docUpdate({ commit }, payload) {
    let response;

    commit(SHOW_DOC);

    try {
      response = await V3API.documentation.docUpdate(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(SHOW_DOC_FAILED);
        reject(response);
      } else {
        commit(SHOW_DOC_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  async docCreate({ commit }, payload) {
    let response;

    commit(SHOW_DOC);

    try {
      response = await V3API.documentation.docCreate(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(SHOW_DOC_FAILED);
        reject(response);
      } else {
        commit(SHOW_DOC_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },
};

const mutations = {
  [GET_DOCS](state) {
    state.loading = true;
  },

  [GET_DOCS_SUCCESS](state, data) {
    state.docs = data;
    state.loading = false;
  },

  [GET_DOCS_FAILED](state) {
    state.loading = false;
  },

  [SHOW_DOC](state) {
    state.loading = true;
  },

  [SHOW_DOC_SUCCESS](state, data) {
    state.docDetails = { ...data };
    state.loading = false;
  },

  [SHOW_DOC_FAILED](state) {
    state.loading = false;
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
